(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-finalized.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-finalized.js');

'use strict';

const _React = React,
  useMemo = _React.useMemo;
const clx = svs.components.lbUtils.clx;
const _svs$components$marke = svs.components.marketplaceCompetition.overviewHero.common,
  CompetitionLogo = _svs$components$marke.CompetitionLogo,
  LoginButton = _svs$components$marke.LoginButton,
  Registration = _svs$components$marke.Registration,
  VisitGameButton = _svs$components$marke.VisitGameButton;
const resolveCompetitionName = svs.components.marketplaceCompetition.helpers.resolveCompetitionName;
const ordinalNumber = svs.components.marketplaceCompetition.overviewHero.helpers.ordinalNumber;
const _svs$components$marke2 = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState,
  IS_NOT_REGISTERED = _svs$components$marke2.IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET = _svs$components$marke2.HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET = _svs$components$marke2.HAS_CURRENT_BET;
const _svs$components$marke3 = svs.components.marketplaceCompetition.competitionHandler.common.constants.competitionStates,
  REG_CLOSED_DRAW_FINALIZED = _svs$components$marke3.REG_CLOSED_DRAW_FINALIZED,
  REG_OPEN_DRAW_FINALIZED = _svs$components$marke3.REG_OPEN_DRAW_FINALIZED;
const UserNotLoggedIn = _ref => {
  let competition = _ref.competition,
    compName = _ref.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Var med och sl\xE5ss om titeln")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let competition = _ref2.competition,
    compName = _ref2.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Anm\xE4l dig till t\xE4vlingen")), React.createElement(Registration, {
    competition: competition
  })));
};
const UserHasNoBet = _ref3 => {
  let competition = _ref3.competition,
    compName = _ref3.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Du deltar i ".concat(compName))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Omg\xE5ngen \xE4r st\xE4ngd f\xF6r k\xF6p."), React.createElement("span", null, "N\xE4sta omg\xE5ng \xF6ppnar snart f\xF6r spel."))));
};
const UserHasBet = _ref4 => {
  let competition = _ref4.competition;
  const _ref5 = (competition === null || competition === void 0 ? void 0 : competition.details) || {},
    firstDrawNumber = _ref5.firstDrawNumber,
    currentDrawNumber = _ref5.currentDrawNumber;
  const competitionStatus = competition === null || competition === void 0 ? void 0 : competition.status;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      let round;
      if (competitionStatus && (competitionStatus === REG_CLOSED_DRAW_FINALIZED || competitionStatus === REG_OPEN_DRAW_FINALIZED)) {
        round = currentDrawNumber - firstDrawNumber;
      } else {
        round = currentDrawNumber - firstDrawNumber + 1;
      }
      return React.createElement("h2", {
        "aria-label": "R\xE4tta ditt spel f\xF6r ".concat(ordinalNumber(round), " omg\xE5ngen"),
        className: "overview-hero-title"
      }, React.createElement("span", {
        "aria-hidden": "true"
      }, "R\xE4tta ditt spel f\xF6r"), React.createElement("span", {
        "aria-hidden": "true"
      }, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "R\xE4tta ditt spel!");
  }, [currentDrawNumber, firstDrawNumber, competitionStatus]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, currentGameTitle, React.createElement(VisitGameButton, {
    competition: competition
  })));
};
const CompetitionOpenDrawFinalized = _ref6 => {
  let competition = _ref6.competition,
    userState = _ref6.userState;
  const compName = resolveCompetitionName(competition);
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          compName: compName
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition,
          compName: compName
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition,
          compName: compName
        });
    }
  };
  return React.createElement("div", {
    className: clx('competition-overview-hero competition-open-draw-finalized', userState)
  }, renderContentBasedOnUserState(userState));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionOpenDrawFinalized', CompetitionOpenDrawFinalized);

 })(window);